var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeaderApp = function SvgHeaderApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 7,
    height: 4,
    rx: 2,
    fill: "#3071EE",
    stroke: "#3071EE",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 7,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 7,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 7,
    height: 4,
    rx: 2,
    fill: "#3071EE",
    stroke: "#3071EE",
    strokeWidth: 1.5
  })));
};
export { SvgHeaderApp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9J2FwcC1pY29uJyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iNCIgd2lkdGg9IjciIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9IiMzMDcxRUUiIHN0cm9rZT0iIzMwNzFFRSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHJlY3QgeD0iNCIgeT0iMTEiIHdpZHRoPSI3IiBoZWlnaHQ9IjEwIiByeD0iMi41IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHJlY3QgeD0iMTQiIHk9IjQiIHdpZHRoPSI3IiBoZWlnaHQ9IjEwIiByeD0iMi41IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHJlY3QgeD0iMTQiIHk9IjE3IiB3aWR0aD0iNyIgaGVpZ2h0PSI0IiByeD0iMiIgZmlsbD0iIzMwNzFFRSIgc3Ryb2tlPSIjMzA3MUVFIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";